<template>
  <div>
    <v-row align-center justify="center" no-gutters>
      <v-col cols="8" class="pa-0">
        <v-row align-center class="orientaion">
          <v-col cols="6">Orientación:</v-col>
          <v-col cols="5">
            <input
              :value="mayus(resultadoCurricula.orientacion)"
              class="order"
              @change="guardarOrientacion($event.target.value)"
            />
          </v-col>
          <v-col cols="1" align-self="center" class="pa-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon class="agregar_materia_icono" v-on="on"
                  >mdi-information</v-icon
                >
              </template>
              <span>Orientación del Agrupamiento</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row align-center justify="center" no-gutters>
      <v-col cols="8" class="pa-0">
        <v-row align-center class="orientaion">
          <v-col cols="6">Nivel:</v-col>
          <v-col cols="5">
            <input
              :value="mayus(resultadoCurricula.nivel)"
              class="order"
              @change="guardarNivelCurso($event.target.value)"
              @keypress="soloNumeros"
            />
          </v-col>
          <v-col cols="1" align-self="center" class="pa-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon class="agregar_materia_icono" v-on="on"
                  >mdi-information</v-icon
                >
              </template>
              <span>Nivel del Agrupamiento</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row align-center justify="center" no-gutters>
      <v-col cols="8" class="pa-0">
        <v-row align-center class="proximo_nivel">
          <v-col cols="6">Próximo Nivel:</v-col>
          <v-col cols="5" class="pt-0 pb-0">
            <v-select
              v-model="proximoCurso"
              ref="proximoCursoText"
              :items="cursoSelect"
              item-text="descripcion"
              item-value="id"
              label="Próximo Curso"
              no-data-text="No hay cursos disponibles"
              @change="guardarProximoCurso($event)"
              :disabled="
                resultadoCurricula.nivel == '' ||
                resultadoCurricula.nivel == undefined
                  ? true
                  : false
              "
            ></v-select>
          </v-col>
          <v-col cols="1" align-self="center" class="pa-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon class="agregar_materia_icono" v-on="on"
                  >mdi-information</v-icon
                >
              </template>
              <span>Curso/nivel al que serán promovido los alumnos</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <template>
      <v-row>
        <v-col cols="6" class="detalle_items">
          <orden
            :materias="resultadoCurricula.result"
            :idAgrupamiento="idAgrupamiento"
            @curriculaOrden:recargarDatos="recargarDatos"
          />
        </v-col>
        <v-col cols="6" class="detalle_items item_derecho">
          <nueva_materia
            :materias_disponibles="materiasDisponibles"
            :idAgrupamiento="idAgrupamiento"
            @curriculaNuevaMateria:recargarDatos="recargarDatos"
            @curriculaOrden:recargarDatos="recargarDatos"
          />
        </v-col>
      </v-row>
    </template>
  </div>
</template>

<script>
import API from "@/components/_config/conf";
import nueva_materia from "./curricula_nueva_materia";
import orden from "./curricula_orden";
export default {
  data() {
    return {
      materias: [],
      cursoSelect: [],
      //cursoNivel: this.resultadoCurricula.nivel,
      proximoCurso: "",
      proximoCursoMensaje: false,
    };
  },
  components: {
    nueva_materia,
    orden,
  },
  props: [
    "resultadoCurricula",
    "materiasDisponibles",
    "idAgrupamiento",
    "cursos",
  ],
  mounted: function () {
    this.crearSelectCursos();
    //this.seleccionarProximoCurso();
  },
  methods: {
    soloNumeros(e) {
      var key = window.event ? e.which : e.keyCode;
      //console.log(key);
      if (key < 48 || key > 57) {
        e.preventDefault();
      }
    },
    crearSelectCursos() {
      this.cursoSelect = [];
      for (const curso in this.cursos) {
        /*console.log(
          this.cursos[curso].nivel,
          this.resultadoCurricula.nivel,
          parseInt(this.resultadoCurricula.nivel) + 1
        );*/
        if (
          this.cursos[curso].nivel ==
          parseInt(this.resultadoCurricula.nivel) + 1
        ) {
          let cursoAux = {
            descripcion: this.cursos[curso].descripcion,
            id: this.cursos[curso].id,
          };

          this.cursoSelect.push(cursoAux);
        }
      }
      this.seleccionarProximoCurso();
    },
    mostrarOcultarPreload: function () {
      this.$emit("curricula_detalle:mostrarOcultarPreload");
    },
    recargarDatos: function (idagrupamiento) {
      this.$emit("curricula_detalle:recargarDatos", idagrupamiento);
    },
    mayus(str) {
      let srt_result;

      if (str != "" && str != null) srt_result = API.ucFirst(str);
      else srt_result = str;
      return srt_result;
    },
    seleccionarProximoCurso: function () {
      for (const curso in this.cursoSelect) {
        if (
          this.cursoSelect[curso].descripcion ==
          this.mayus(this.resultadoCurricula.proximoCurso)
        ) {
          this.proximoCurso = {
            descripcion: this.cursoSelect[curso].descripcion,
            id: this.cursoSelect[curso].id,
          };
        }
      }
      /*let elem = {
        id: 0,
        descripcion: "FINAL"
      };*/
      //this.cursoSelect.push(elem);
    },
    guardarOrientacion: function (orientacion) {
      let params = "idAgrupamiento=" + this.idAgrupamiento;
      params += "&orientacion=" + orientacion;

      let resultado = API.enviar("get", "guardarOrientacion", params);

      resultado
        .then((result) => {
          if (result.data.msj == "ok") this.recargarDatos(this.idAgrupamiento);
        })
        .catch(() => {
          //this.$emit("curricula_detalle:mostrarOcultarPreload");
        });
    },
    guardarNivelCurso: function (event) {
      console.log("guardarNivelCurso", event);
      let params = "idAgrupamiento=" + this.idAgrupamiento;
      params += "&nivel=" + event;
      let resultado = API.enviar("get", "guardarNivelCurso", params);

      resultado
        .then((result) => {
          if (result.data.msj == "ok") this.recargarDatos(this.idAgrupamiento);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    guardarProximoCurso: function (event) {
      for (const curso in this.cursoSelect) {
        if (this.cursoSelect[curso].id == event) {
          var proximoCurso = this.cursoSelect[curso].descripcion;

          /*if (this.cursos[curso].descripcion == "FINAL") proximoCurso = null;
          else proximoCurso = this.cursos[curso].descripcion;*/
        }
      }

      let params = "idAgrupamiento=" + this.idAgrupamiento;
      params += "&proximoCurso=" + proximoCurso;
      let resultado = API.enviar("get", "guardarProximoCurso", params);

      resultado
        .then((result) => {
          if (result.data.msj == "ok") this.recargarDatos(this.idAgrupamiento);
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  watch: {
    resultadoCurricula: function () {
      this.materias = this.resultadoCurricula.result;
      //this.seleccionarProximoCurso();
      this.crearSelectCursos();
      /*console.log(
        "watch cursoNivel: ",
        this.resultadoCurricula.nivel,
        this.$refs.cursoList
      );*/
    },
    idAgrupamiento: function () {
      //this.crearSelectCursos();
      //console.log("watch cursoNivel: ", this.cursoNivel);
    },
  },
};
</script>

<style scoped>
.detalle_items {
  border-top: solid 1px #ccc;
  padding-top: 10px;
}

.item_derecho {
  border-left: solid 1px #ccc;
}

.orientaion {
  font-size: 18px;
  padding: 10px 0px;
}

.proximo_nivel {
  font-size: 18px;
  padding: 0px;
}
</style>